export function mapSqlTypeToVueType(sqlType: string): string {
  const normalized = sqlType.trim().toLowerCase();

  // Remove size/scale if present, e.g., varchar(50) -> varchar
  const baseType = normalized.split('(')[0];

  const typeMap: { [key: string]: string } = {
    // String types
    'char': 'string',
    'nchar': 'string',
    'varchar': 'string',
    'nvarchar': 'string',
    'text': 'string',
    'ntext': 'string',
    // Number types
    'int': 'number',
    'smallint': 'number',
    'tinyint': 'number',
    'bigint': 'number',
    'decimal': 'number',
    'numeric': 'number',
    'float': 'number',
    'real': 'number',
    'money': 'currency',
    'smallmoney': 'currency',
    // Boolean
    'bit': 'boolean',
    // Date and time
    'date': 'date',
    'datetime': 'datetime',
    'datetime2': 'datetime',
    'smalldatetime': 'datetime',
    'datetimeoffset': 'datetime',
    'time': 'time',
    // Binary / File
    'binary': 'file',
    'varbinary': 'file',
    'image': 'picture',
    // Special/Other
    'uniqueidentifier': 'string', // or 'uuid'
    'xml': 'string',
    'json': 'json',
    'sql_variant': 'object',
    // Add more if needed
  };

  // Fallbacks for special Vue3 types based on naming conventions
  if (baseType.includes('image') || baseType.includes('picture')) return 'picture';
  if (baseType.includes('file')) return 'file';
  if (baseType.includes('html')) return 'html';
  if (baseType.includes('markdown')) return 'markdown';
  if (baseType.includes('richtext')) return 'richtext';
  if (baseType.includes('color')) return 'color';
  if (baseType.includes('email')) return 'email';
  if (baseType.includes('url')) return 'url';
  if (baseType.includes('phone')) return 'phone';
  if (baseType.includes('ip')) return 'ip';
  if (baseType.includes('percent')) return 'percentage';
  if (baseType.includes('currency')) return 'currency';

  // Default mapping
  return typeMap[baseType as string] || 'string';
}

export function isNumberType(type: string): boolean {
  return [
    'int', 'smallint', 'tinyint', 'bigint',
    'decimal', 'numeric', 'float', 'real'
  ].includes(type);
}